import { render, staticRenderFns } from "./Automation.vue?vue&type=template&id=7d9445c8&scoped=true&"
import script from "./Automation.vue?vue&type=script&lang=ts&"
export * from "./Automation.vue?vue&type=script&lang=ts&"
import style0 from "./Automation.vue?vue&type=style&index=0&id=7d9445c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d9445c8",
  null
  
)

export default component.exports